import React from 'react';
import { FormattedMessage } from 'react-intl';
import {
  SuggestionCardContainer,
  SuggestionCardHeader,
  SuggestionCardIcon,
  SuggestionCardIconSymbol,
  SuggestionCardTitle,
  SuggestionCardBody,
  SuggestionCardActions,
  SuggestionProceedButton,
  SuggestionDismissButton,
} from './ModelSuggestionCard.styled';

/** Card shown when the gate suggests a better-suited model (AIB-7877). */
const ModelSuggestionCard: React.FC<{
  suggestedModelLabel: string;
  canAct?: boolean;
  onAccept?: () => void;
  onDismiss?: () => void;
}> = ({ suggestedModelLabel, canAct = false, onAccept, onDismiss }) => (
  <SuggestionCardContainer>
    <SuggestionCardHeader>
      <SuggestionCardIcon>
        <SuggestionCardIconSymbol className="material-symbols-outlined">
          auto_awesome
        </SuggestionCardIconSymbol>
      </SuggestionCardIcon>
      <SuggestionCardTitle>
        <FormattedMessage
          id="chat.modelSuggestion.title"
          defaultMessage="Try a better-suited model"
        />
      </SuggestionCardTitle>
    </SuggestionCardHeader>
    <SuggestionCardBody>
      <FormattedMessage
        id="chat.modelSuggestion.body"
        defaultMessage="{model} is better suited for this kind of task. Switch to it and continue?"
        values={{ model: suggestedModelLabel }}
      />
    </SuggestionCardBody>
    {canAct && onAccept && onDismiss && (
      <SuggestionCardActions>
        <SuggestionDismissButton type="button" onClick={onDismiss}>
          <FormattedMessage
            id="chat.modelSuggestion.dismiss"
            defaultMessage="Continue with current model"
          />
        </SuggestionDismissButton>
        <SuggestionProceedButton type="button" onClick={onAccept}>
          <FormattedMessage
            id="chat.modelSuggestion.accept"
            defaultMessage="Switch to {model} and continue"
            values={{ model: suggestedModelLabel }}
          />
        </SuggestionProceedButton>
      </SuggestionCardActions>
    )}
  </SuggestionCardContainer>
);

export default ModelSuggestionCard;
